import { useEffect, useState } from 'react';

/** 값이 delayMs 동안 바뀌지 않으면 그 값을 돌려준다(입력 중 요청을 줄인다) */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
